import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Features | Canny';
const Description =
  'A list of the core Canny features. From feedback to feature release, Canny helps your team complete the feedback loop.';
const Image = 'https://canny.io/images/canny-social.png';
const FeaturesUrl = 'https://canny.io/features';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${FeaturesUrl}#webpage`,
    url: FeaturesUrl,
    name: 'Canny Features',
    description:
      "Explore Canny's features for collecting, analyzing, and acting on user feedback to build better products.",
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(`${FeaturesUrl}#list`, 'Canny Feature List', [
    {
      name: 'Collect Feedback',
      url: `${FeaturesUrl}/collect-feedback`,
      description:
        'Collect feedback via public boards, in-app widgets, and integrations with tools like Intercom, Zendesk, and Slack.',
    },
    {
      name: 'Analyze Feedback',
      url: `${FeaturesUrl}/analyze-feedback`,
      description:
        'Enrich feedback with business data, segment by customer value, and uncover deeper insights.',
    },
    {
      name: 'Product Roadmap',
      url: `${FeaturesUrl}/product-roadmap`,
      description:
        'Plan and communicate product roadmaps, prioritize requests, and align stakeholders.',
    },
    {
      name: 'Product Changelog',
      url: `${FeaturesUrl}/product-changelog`,
      description: 'Publish updates and announce new features to keep users informed and engaged.',
    },
    {
      name: 'Bug Tracking',
      url: 'https://canny.io/use-cases/bug-tracking-tool',
      description:
        'Track, prioritize, and resolve bugs alongside feature requests to ensure product quality.',
    },
    {
      name: 'Autopilot (AI)',
      url: `${FeaturesUrl}/autopilot`,
      description:
        'AI-powered feedback discovery, smart replies, comment summaries, and deduplication.',
    },
  ]),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Features', item: FeaturesUrl },
  ]),
]);

export default class LandingFeaturesHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: FeaturesUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
